import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const PeerSupportRedirect = () => {
  const { forumId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('=== PEER SUPPORT REDIRECT DEBUG ===');
    console.log('Redirecting from:', `/peer-support/forum/${forumId}`);
    console.log('Redirecting to:', `/app/peer-support/forum/${forumId}`);
    // Redirect to the correct path with /app prefix
    navigate(`/app/peer-support/forum/${forumId}`, { replace: true });
  }, [forumId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
    </div>
  );
};

export default PeerSupportRedirect; 